<div class="menu-item">
  @if (item().route) {
    <a
      mat-button
      [routerLink]="item().route"
      routerLinkActive="selected-menu-item"
      #rla="routerLinkActive"
      [activated]="rla.isActive"
      [class.unselected-menu-item]="selected() !== item().label"
      [class.home-selected]="selected() === 'Home'"
      (click)="selectedItem(item().label)"
      [matMenuTriggerFor]="item().subMenu ? menu1 : null"
      #menuTrigger="matMenuTrigger"
      (mouseenter)="item().subMenu ? mouseEnter(menuTrigger) : null"
      (mouseleave)="item().subMenu ? mouseLeave(menuTrigger) : null"
    >
      <mat-icon [svgIcon]="item().icon" />

      @if (!collapsed()) {
        {{ item().label }}
      }
    </a>
  } @else {
    <a
      mat-button
      [matMenuTriggerFor]="menu1"
      #menuTrigger="matMenuTrigger"
      (mouseenter)="mouseEnter(menuTrigger)"
      (mouseleave)="mouseLeave(menuTrigger)"
      [class.unselected-menu-item]="selected() !== item().label"
      [class.selected-menu-item]="selected() === item().label"
      [class.add-menu-separator]="!collapsed()"
    >
      <mat-icon [svgIcon]="item().icon" />
      @if (!collapsed()) {
        {{ item().label }}
      }
    </a>
  }
  <mat-menu #menu1="matMenu" [overlapTrigger]="false" [hasBackdrop]="false">
    @for (subMenu of item().subMenu; track subMenu.route; let first = $first) {
      <a
        mat-menu-item
        [class.remove-top-border]="first"
        (mouseenter)="mouseEnter(menuTrigger)"
        (mouseleave)="mouseLeave(menuTrigger)"
        [routerLink]="subMenu.route"
        routerLinkActive="selected-menu-item"
        #rla="routerLinkActive"
        [activated]="rla.isActive"
        [style.font-weight]="400"
        (click)="selectedItem(item().label)"
      >
        {{ subMenu.label }}
      </a>
    }
  </mat-menu>
</div>
